import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Footer from "../../core/common/Footer";

const ColorCode = () => {
  const [showGuide, setShowGuide] = useState<boolean>(true);

  const colorOptions = [
    { name: "GREEN", color: "#198754" },
    { name: "RED", color: "#dc3545" },
    { name: "YELLOW", color: "#ffc107" },
    { name: "ORANGE", color: "#fd7e14" },
    { name: "MAROON", color: "#5c0011" },
    { name: "GREY", color: "#495057" },
    { name: "BLUE", color: "#0d6efd" },
    // { name: "BLACK", color: "#000000" },
    // { name: "ORANGE", color: "#fd7e14" },
    // { name: "BLACK", color: "#000000" },
    // { name: "MAROON", color: "#5c0011" },
  ];

  const statusList = [
    { label: "GREEN", textColor: "#198754" },
    { label: "RED", textColor: "#dc3545" },
    { label: "YELLOW", textColor: "#ffc107" },
    { label: "ORANGE", textColor: "#fd7e14" },
    { label: "ORANGE", textColor: "#fd7e14" },
    { label: "ORANGE", textColor: "#fd7e14" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Color Code Settings</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.superAdminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Account Activation</li>
                <li className="breadcrumb-item active">Color Code Settings</li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>
        {/* <GuideContainer
          showGuide={showGuide}
          handleClick={() => setShowGuide((prev) => !prev)}
        /> */}
        <div className="text-end mt-3">
          <button
            className="btn border bg-white px-3"
            onClick={() => setShowGuide((prev) => !prev)}
          >
            <i className="ti ti-info-circle-filled fs-16"></i> Guide
          </button>
        </div>
        {showGuide && (
          <div
            style={{
              overflow: "hidden",
              maxHeight: showGuide ? "500px" : "0px",
              transition: "all 0.4s ease",
            }}
          >
            {/* Top Arrow */}
            <div className="text-end pe-3">
              <i
                className="ti ti-triangle-inverted-filled"
                style={{
                  fontSize: "22px",
                  color: "#cfcfcf",
                  lineHeight: 0,
                }}
              ></i>
            </div>

            {/* Guide Box */}
            <div
              className="card border-0 shadow-sm"
              style={{
                borderRadius: "4px",
              }}
            >
              <div className="card-body position-relative p-4">
                {/* Close Button */}
                <div className="position-absolute top-0 end-0 mt-3 me-3">
                  <i
                    className="ti ti-x"
                    style={{
                      background: "#6c757d",
                      color: "#fff",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      fontSize: "12px",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setShowGuide(false)}
                  />
                </div>

                {/* Heading */}
                <h5 className="fw-bold mb-3">Color Code Settings</h5>

                {/* Description */}
                <p className="mb-3 small">
                  This tab is to assign the respective color codes for the
                  client. There are 3 pre-set levels. The color for the
                  respective risk matrix can be set by selecting the color code
                  tab.
                </p>

                {/* Table */}
                <div className="table-responsive">
                  <table className="table table-bordered mb-3">
                    <thead className="table-dark">
                      <tr className="text-center">
                        <th className="bg-dark text-white">OPTION 1</th>
                        <th className="bg-dark text-white">OPTION 2</th>
                        <th className="bg-dark text-white">OPTION 3</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td className="text-dark">Clear - Green</td>
                        <td className="text-dark">Clear - Green</td>
                        <td className="text-dark">Positive - Green</td>
                      </tr>

                      <tr>
                        <td className="text-dark">Discrepancy - Red</td>
                        <td className="text-dark">Major Discrepancy - Red</td>
                        <td className="text-dark">Positive Review - Green</td>
                      </tr>

                      <tr>
                        <td className="text-dark">Consider - Orange</td>
                        <td className="text-dark">
                          Minor Discrepancy - Yellow
                        </td>
                        <td className="text-dark">Negative - Red</td>
                      </tr>

                      <tr>
                        <td className="text-dark">
                          Insufficiency Expired - Orange
                        </td>
                        <td className="text-dark">Consider - Orange</td>
                        <td className="text-dark">Negative Review - Red</td>
                      </tr>

                      <tr>
                        <td className="text-dark">UTV - Orange</td>
                        <td className="text-dark">
                          Insufficiency Expired - Orange
                        </td>
                        <td className="text-dark">
                          Insufficiency Expired - Orange
                        </td>
                      </tr>

                      <tr>
                        <td className="text-dark"></td>
                        <td className="text-dark">UTV - Orange</td>
                        <td className="text-dark">UTV - Orange</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Note */}
                <div>
                  <p className="mb-1">
                    <strong>Note :</strong> The common status for all the
                    respective color codes will be:
                  </p>

                  <p className="mb-1">STOP – No Color Code</p>

                  <p className="mb-1">Pending – No Color Code</p>

                  <p className="mb-1">
                    Insufficiency Expired – Orange / Client Specific
                  </p>

                  <p className="mb-0">UTV – Orange / Client Specific</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Table  */}
        <div className="card mt-3 shadow-sm border-0">
          <div className="card-body">
            <h6 className="fw-semibold mb-4 pb-2 border-bottom">
              Choose Color Code Matrix
            </h6>

            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th style={{ width: "35%" }}>Check Status</th>
                    <th>Color</th>
                  </tr>
                </thead>

                <tbody>
                  {statusList.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          color: item.textColor,
                          fontWeight: 500,
                        }}
                      >
                        {item.label}
                      </td>

                      <td>
                        <div className="d-flex align-items-center gap-4 flex-wrap">
                          {colorOptions.map((option) => {
                            const isSelected =
                              option.name.toUpperCase() ===
                              item.label.toUpperCase();

                            return (
                              <span
                                key={option.name}
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  borderRadius: "50%",
                                  background: option.color,
                                  display: "inline-block",
                                  outline: isSelected
                                    ? "2px solid #a5d6a7"
                                    : "none",
                                  outlineOffset: "2px",
                                }}
                              />
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mt-5">
                <p
                  className="p-3 rounded-1 text-dark mb-0"
                  style={{
                    backgroundColor: "#fdecef",
                    border: "1px solid #f5c2c7",
                  }}
                >
                  Color code can only be given to checks which has been
                  processed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ColorCode;
